import { ArrowRightIcon } from '@phosphor-icons/react'
import { colors } from '@pixee/design-system'
import { Spinner } from '../spinner.tsx'
import * as styles from './progress-button.css.ts'

export type ProgressButtonProps = {
  label: string
  onClick: () => unknown
  disabled?: boolean
}

export const ProgressButton: React.FC<ProgressButtonProps> = ({ label, onClick, disabled = false }) => {
  return (
    <button
      className={styles.button({ isDisabled: disabled })}
      onClick={onClick}
      disabled={disabled}
      aria-disabled={disabled}
    >
      <Spinner size="16" variant="unthemed" label={`${label} loading`} />
      <span className={styles.label}>{label}</span>
      <ArrowRightIcon size={16} weight="light" color={colors.neutral.halo} />
    </button>
  )
}
